import { Package } from "lucide-react";
import type { ReactNode } from "react";

interface CaixasPageHeaderProps {
  action?: ReactNode;
}

export function CaixasPageHeader({ action }: CaixasPageHeaderProps) {
  return (
    <div className="caixas-page-header">
      <div style={{ display: "flex", alignItems: "center", gap: "0.85rem" }}>
        <div className="caixas-page-header-icon" aria-hidden="true">
          <Package size={18} />
        </div>
        <div style={{ minWidth: 0 }}>
          <h1>CAIXAS</h1>
        </div>
      </div>
      {action ? (
        <div className="caixas-page-header-action">{action}</div>
      ) : null}
    </div>
  );
}
